// extracted by mini-css-extract-plugin
export default {"success__header-title":"InfoAlert_success__header-title__zqlbb","success__header-icon":"InfoAlert_success__header-icon__PjfWM","success__content":"InfoAlert_success__content__DlEu4"};